import { render } from "./UiBadge.vue?vue&type=template&id=6c3b0822&ts=true"
import script from "./UiBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiBadge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c3b0822"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c3b0822', __exports__)) {
    api.reload('6c3b0822', __exports__)
  }
  
  module.hot.accept("./UiBadge.vue?vue&type=template&id=6c3b0822&ts=true", () => {
    api.rerender('6c3b0822', render)
  })

}


export default __exports__